import { useNotify } from '@globaleris/ui.library'
import { Button, Typography } from '@material-ui/core'
import { QlikUIContext, QlikWrapper, Report } from 'globaleris-qlik-component'
import 'globaleris-qlik-component/dist/index'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'
import Page, { PageLayout } from '../../../components/page/page'
import PageCenterColumn from '../../../components/page/pageCenterColumn'
import PageHeader from '../../../components/page/pageHeader'
import { useQlikContext } from '../../../hooks/useQlikContext'

export interface InvoiceCycleReportProps {
  executionCycleId?: number
}

interface LocationState {
  executionCycleId?: number
  reportId?: string
}

export const InvoiceCycleReportPage: React.FC<InvoiceCycleReportProps> = () => {
  const [t] = useTranslation(['globalerisLibrary', 'invoiceCyclesReport'])
  const { isContextInitialized, context } = useQlikContext()
  const location = useLocation<LocationState>()
  const history = useHistory()
  const { error } = useNotify()

  const executionCycleId = location.state?.executionCycleId
  const reportIdFromState = location.state?.reportId

  const fileName = useMemo(() => {
    return reportIdFromState ?? ''
  }, [reportIdFromState])

  const handleGoBack = () => {
    history.goBack()
  }

  const renderErrorContent = () => (
    <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <Typography variant="h6" color="error">
        {t('invoiceCyclesReport:errors.missingExecutionCycle')}
      </Typography>
    </div>
  )

  return (
    <Page layout={PageLayout.SINGLE_COLUMN} fullWidth={true}>
      <PageCenterColumn>
        <PageHeader title={`${t('invoiceCyclesReport:title')}`}>
          <Button variant="text" color="primary" onClick={handleGoBack}>
            {t('invoiceCyclesReport:buttons.goBack')}
          </Button>
        </PageHeader>
        {!executionCycleId
          ? renderErrorContent()
          : isContextInitialized && (
              <QlikUIContext.Provider value={context}>
                {
                  <QlikWrapper
                    component={
                      <Report
                        fileName={fileName}
                        reportType={1}
                        dimensions={[
                          {
                            Dimension: 'ID_EJECUCION_CICLO_FACTURACION',
                            Value: `${executionCycleId}`
                          }
                        ]}
                      />
                    }
                  />
                }
              </QlikUIContext.Provider>
            )}
      </PageCenterColumn>
    </Page>
  )
}
